export default {"src":"/_next/static/media/wicc.4291c3da.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};